import React from 'react';
import { StatusWrapper } from './styles/Status.styles';
import { getColorForStatus } from '../utilities';
import { statusLabels } from '../constants/status';

type StatusProps = {
  status: string;
};

const Status = ({ status }: StatusProps) => {
  if (!status) return null;
  const copyForStatus = statusLabels[status as keyof typeof statusLabels];
  const statusColor = getColorForStatus(status);

  return (
    <>
      <StatusWrapper statusColor={statusColor}>
        <p>
          {copyForStatus}
        </p>
      </StatusWrapper>
    </>
  );
};

export default Status;
